import router from '@/router'

import { isNavigationFailure, NavigationFailureType } from 'vue-router'

export const openNewPage = (routerData) => {
  const routeData = router.resolve(routerData)
  window.open(routeData.href, '_blank')
}

export const goBack = () => router.back()

export const goMain = () => router.push({ name: 'showcase' })

export const goAccreditation = () => router.push({ name: 'accreditation' })

export const goLotInfo = (id, name) => router.push({ name, params: { id } })

export const goSitno = () => {
  console.log('here')
  window.location.href = 'https://tender-demo.analyticumplus.ru/'
}

export const goVK = () => {
  window.location.href = 'https://vk.com/tender-demo_official'
}

export const goCookiePolitic = () => {
  window.location.href = 'https://tender-demo.ru/politika-obrabotki-personalnyh-dannyh'
}

export const goLotOrganizer = () => router.push({ name: 'create-trade' })

export function goToPage(name, params, isRightClick = false) {
  if (isRightClick) {
    const routeData = router.resolve({ name, params })
    window.open(routeData.href, '_blank')
    return
  }
  return router.push({ name, params }).catch(onErrorNavigation)
}

function onErrorNavigation(error) {
  if (isNavigationFailure(error, NavigationFailureType.duplicated)) return

  console.error(error)
}

export function goLotOffer() {
  return goToPage('bidder-lot-create', { id: router.currentRoute.value.params.id })
}

export function goToAdminUser(row) {
  return goToPage('admin-user', { id: row.item.id }, row?.rightClick)
}

export function goToSecurityUser(row) {
  return goToPage('security-user', { id: row.item.id }, row?.rightClick)
}
